import { apiCall } from "../../service/api-service";

export const getVisitorPredictionApi = async (date) => {
  return apiCall("GET", `futuristic_dashboard/visitors?date=${date}`);
};

export const getVehiclePredictionApi = async (date) => {
  return apiCall("GET", `futuristic_dashboard/vehicles?date=${date}`);
};

export const getCourierPredictionApi = async (date) => {
  return apiCall("GET", `futuristic_dashboard/couriers?date=${date}`);
};

export const getVisitorPeakTimeApi = async (date) => {
  return apiCall("GET", `futuristic_dashboard/visitor_peak_time`);
};

export const getVisitorEntryApi = async (date) => {
  return apiCall("GET", `futuristic_dashboard/entry_based`);
};

export const getOverstayApi = async (date) => {
  return apiCall("GET", `futuristic_dashboard/overstay_based`);
};

export const getDailyAttendanceApi = async (date) => {
  return apiCall("GET", `futuristic_dashboard/daily_attendance`);
};

export const getPurposePredictionApi = async (date) => {
  return apiCall("GET", `futuristic_dashboard/purpose_based`);
};

export const getRegisterPredictionApi = async (date) => {
  return apiCall("GET", `futuristic_dashboard/registration_based`);
};

export const getPersonPredictionApi = async (date) => {
  return apiCall("GET", `futuristic_dashboard/person_based`);
};

export const getGatePredictionApi = async (date) => {
  return apiCall("GET", `futuristic_dashboard/gate_based`);
};
